export const ACTION_SET_LOAN_PARAMS = "ACTION_SET_LOAN_PARAMS";
